
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,} from "react-router-dom";
import Menu from "../components/Menu";
import ActualizarCv from "../pages/ActualizarCv";
import { Admin } from "../pages/Admin";
import { Login } from "../pages/Login";
import NotFound from "../pages/NotFoundPage";
import { Registro } from "../pages/Registro";
import Reportes from "../pages/Reportes";
import PanelEmpleados from "../pages/PanelEmpleados";
import AutorizacionSalida from "../pages/AutorizacionSalida";
import Comision from "../pages/Comision";
import HistorialSalidas from "../pages/HistorialSalidas";
import SolicitudesSalida from "../pages/SolicitudesSalida";
import PaginaEmpleados from "../pages/PaginaEmpleados";
import ListadoDeArchivos from "../components/ListadoDeArchivos";
import HistorialComisiones from "../pages/HistorialComisiones";
import ComisionAdmin from "../pages/ComisionAdmin";
import SolicitarVacaciones from "../pages/SolicitarVacaciones";
import VacacionesAdmin from "../pages/VacacionesAdmin";
import Notificaciones from "../pages/Notificaciones";
import VacacionesEmpleado from "../pages/VacacionesEmpleado";

export default function AppRouter() {
  return (
    <Router>
      <Switch>

        <Route path="/" exact>
          <Menu component={Login} />
        </Route>

        <Route path="/registro" exact>
          <Menu component={Registro} />
        </Route>

        <Route path="/menu" exact>
          <Menu component={PanelEmpleados} />
        </Route>

		<Route path="/solicitar-vacaciones" exact>
          <Menu component={SolicitarVacaciones} />
        </Route>

        <Route path="/admin" exact>
          <Menu component={Admin} />
        </Route>

        <Route path="/actualizar-cv" exact>
          <Menu component={ActualizarCv} />
        </Route>

        <Route path="/reportes" exact>
          <Menu component={Reportes} />
        </Route>

        <Route path="/autorizacion_salida" exact>
          <Menu component={AutorizacionSalida} />
        </Route>

        <Route path="/comision" exact>
          <Menu component={Comision} />
        </Route>

        <Route path="/historial_salidas" exact>
          <Menu component={HistorialSalidas} />
        </Route>

        <Route path="/admin/solicitudes_salida" exact>
          <Menu component={SolicitudesSalida} />
        </Route>

        <Route path="/admin/lista_empleados" exact>
          <Menu component={PaginaEmpleados} />
        </Route>

        <Route path="/admin/archivos" exact>
          <Menu component={ListadoDeArchivos} />
        </Route>

        <Route path="/historial_comisiones" exact>
          <Menu component={HistorialComisiones} />
        </Route>

        <Route path="/admin/comision" exact>
          <Menu component={ComisionAdmin} />
        </Route>

        <Route path="/admin/vacaciones" exact>
          <Menu component={VacacionesAdmin} />
        </Route>

        <Route path="/admin/vacaciones/:id" exact>
          <Menu component={VacacionesEmpleado} />
        </Route>

        <Route path="/admin/notificaciones" exact>
          <Menu component={Notificaciones} />
        </Route>

        <Route path="/404" component={NotFound} />

        <Route>
          <Redirect to="/404" />
        </Route>
      </Switch>
    </Router>
  );
}
